import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  background-color: ${props => props.theme.colors.background.secondary};
  padding: ${props => props.theme.spacing.sp24};
  border-radius: ${props => props.theme.primitives.radius.radius6};
`
